/**
 * RESPONSIBILITY: open every map link on the page in a new tab, whoever drew it.
 *
 * Components that draw a location button set target="_blank" themselves (mapTarget). This
 * catches the rest: a map link an editor typed into a paragraph, a button an editor
 * pointed at a map, anything rendered from markdown — none of which a component gets to
 * decorate. One listener on the document, so a link added tomorrow is covered without
 * anybody remembering to.
 *
 * A modified click (Ctrl, Cmd, Shift, middle button) is left to the browser: the person
 * has already said where they want it to open.
 */
import { useEffect } from 'react';
import { isMapLink } from './site/commons/map-link';

export function useMapLinksInNewTab(): void {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = (e.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
      if (!a || a.target === '_blank' || !isMapLink(a.href)) return;
      e.preventDefault();
      window.open(a.href, '_blank', 'noopener,noreferrer');
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
}
